(function () {
  'use strict';
  var TlpsModalController = function (
    $scope,
    $state,
    $uibModalInstance,
    labelSrvc,
    propostaTelepassSrvc,
    traslocoTelepassSrvc,
    postVenditaTelepassSrvc,
    messaggiFctr,
    CONSTANTS
  ) {
    $scope.msg = labelSrvc.getLabel;

    this.$scope = $scope;
    this.$state = $state;
    this.$uibModalInstance = $uibModalInstance;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.postVenditaTelepassSrvc = postVenditaTelepassSrvc;

    this.CONSTANTS = CONSTANTS;

    this.mainSrvc;

    this.messaggiFctr = messaggiFctr;
    var self = this;

    this.chiudiModale = function () {
      self.$uibModalInstance.dismiss();
    };

    this.annullaIsDisabled = function () {
      if (self.mainSrvc.datiPratica && (self.mainSrvc.datiPratica.nota == '' || !self.mainSrvc.datiPratica.nota)) {
        return true;
      }
      return false;
    };

    this.annulla = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      self.mainSrvc.pulisciDati(self.mainSrvc.datiPratica);

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseAnnullaPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;

          self.$uibModalInstance.dismiss();
        });
    };

    this.rifiuta = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      self.mainSrvc.pulisciDati(self.mainSrvc.datiPratica);

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseRifiutaPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          var message = {};
          message.type = 'I';
          message.message = 'Richiesta effettuata con successo';
          self.messaggiFctr.addMessage(message);

          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;
          self.$uibModalInstance.dismiss();
        });
    };

    this.revisiona = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseRevisionaPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;

          self.$uibModalInstance.dismiss();
        });
    };

    this.risottometti = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      if (
        self.mainSrvc.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.TRASLOCO_TELEPASS ||
        self.mainSrvc.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.ALLESTIMENTO_VIACARD ||
        self.mainSrvc.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.ALLESTIMENTO_TELEPASS
      ) {
        self.mainSrvc.pulisciDati(self.mainSrvc.datiPratica);
        var dataSottoscrizioneContratto = new Date(self.mainSrvc.datiPratica.dataSottoscrizioneContratto);
        var year = dataSottoscrizioneContratto.getFullYear();
        var month = dataSottoscrizioneContratto.getMonth() + 1;
        var day = dataSottoscrizioneContratto.getDate();
        self.mainSrvc.datiPratica.dataSottoscrizioneContratto = day + '/' + month + '/' + year;
      }

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseRisottomettiPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          var message = {};
          message.type = 'I';
          message.message = 'Richiesta effettuata con successo';
          self.messaggiFctr.addMessage(message);

          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;
          self.$uibModalInstance.dismiss();
        });
    };

    this.revocaContratto = function () {
      self.messaggiFctr.resetMessages();
      self.mainSrvc.spinner.showSpinner = true;

      self.mainSrvc
        .promiseRevocaTelepass(self.mainSrvc.ndgContrattoDaRevocare, self.mainSrvc.contrattoDaRevocare)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.mainSrvc.spinner.showSpinner = false;
            return;
          }
          messaggiFctr.addMessage({
            type: 'I',
            message: 'Richiesta effettuata correttamente'
          });
          self.mainSrvc.recuperaContratti();
          self.$uibModalInstance.dismiss();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;
        });
    };

    this.selectCurrentService = function () {
      if (!!self.propostaTelepassSrvc.datiPratica) {
        return self.propostaTelepassSrvc;
      }

      if (!!self.traslocoTelepassSrvc.datiPratica) {
        return self.traslocoTelepassSrvc;
      }

      if (!!self.postVenditaTelepassSrvc.datiPratica) {
        return self.postVenditaTelepassSrvc;
      }

      if (!!self.postVenditaTelepassSrvc.contrattoDaRevocare) {
        return self.postVenditaTelepassSrvc;
      }
      return null;
    };

    this.init = function () {
      self.mainSrvc = self.selectCurrentService();

      if (self.mainSrvc.datiPratica && self.mainSrvc.datiPratica.nota) {
        self.mainSrvc.datiPratica.nota = '';
      }
    };

    this.init();
  };
  TlpsModalController.$inject = [
    '$scope',
    '$state',
    '$uibModalInstance',
    'TlpsLabelSrvc',
    'TlpsPropostaSrvc',
    'TlpsTraslocoTelepassSrvc',
    'TlpsPostVenditaSrvc',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS'
  ];
  angular.module('cbl.telepass.wa').controller('TlpsModalController', TlpsModalController);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsModale/tlpsModale.cmpt.js
// module id = 32
// module chunks = 0